import {
    Alert,
    Button,
    Card,
    CardContent,
    Divider,
    Stack,
    Typography,
    Box,
    IconButton,
    Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import userServices from "../../../../services/userServices";
import { useNavigate } from "react-router-dom";
import Label from "../../../../components/label";
import { ConfirmActionModal } from "../../../../components/modals/confirmActionModal";
import { useSnackbar } from "notistack";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { alpha } from "@mui/material/styles";

import HufDltWallet from "./HufDltWallet";
import { BankAccount } from "../../../../components/bankAccount";
import bankServices from "../../../../services/bankServices";

function HufProfile({ hufHeadDetails, url ,getHufDetails }) {
   
    const user = useSelector(state => state.user.data);
    const navigate = useNavigate();

    const [actionModal, setActionModal] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
   

    const handleDeleteHuf = async (hufId) => {
        const res = await userServices.deleteHufDetails(hufId, user._id)
        if (res && res.success) {
            navigate("/dashboard/profile");
            enqueueSnackbar("Deleted Successfully", {
                variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" },
                autoHideDuration: 3000,
            });
            await getHufDetails();
        }
        else {
            enqueueSnackbar("Something went wrong!", {
                variant: "error",
                anchorOrigin: { horizontal: "right", vertical: "top" },
                autoHideDuration: 3000,
            });
        }
    }
   

    const HUFStatus = {
        "REJECTED": "REJECTED",
        "KYC_COMPLETE": "KYC Submitted, Approval Pending From Admin",
        "KYC_APPROVED": "KYC Approved",
        "APPROVED": "APPROVED"
    }


    return (
        hufHeadDetails?.map((row) => {
            const isKycApprovedOrApproved =
                row?.huf?.status === "KYC_APPROVED" || row?.huf?.status === "APPROVED";
            return (
                <Card 
                sx={{ 
                    margin: 1, 
                    padding: {xs: 0, sm: 2}, 
                    width: "100%",
                    minWidth: { xs: "100%", md: '30%' }, 
                    boxShadow: 1, 
                    ...(isKycApprovedOrApproved
                        ? {
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            alignItems: "stretch",
                            justifyContent: "space-between",
                            gap: { xs: 2, md: 0 },
                        }
                        : {})
                }}
            >
                    <ConfirmActionModal open={actionModal} setOpen={setActionModal} handleYes={() => handleDeleteHuf(row?.entityId)} data={row?.entityId} />
                    <CardContent
                        sx={
                            isKycApprovedOrApproved
                                ? { width: { xs: "100%", md: "40%" } }
                                : {}
                        }
                    >
                        <Stack rowGap={2}>
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center"
                                // flexWrap="wrap"
                                sx={{ width: "100%" }}
                            >
                                <Box sx={{ minWidth: 0, flex: "1 1 auto" }}>
                                    {row?.huf?.status ?
                                        <Label
                                            sx={{
                                                py: 2,
                                                px: 2,
                                                fontWeight: 600,
                                                fontSize: { xs: 8, sm: 12 },
                                                maxWidth: "100%",
                                                wordBreak: "break-word",
                                            }}
                                            variant="ghost"
                                            color={row?.huf?.status == 'PENDING' ? 'warning' : row?.huf?.status == 'REJECTED' ? 'error' : row?.huf?.status == 'APPROVED' ? 'success' : row?.huf?.status == 'KYC_APPROVED' ? 'success': row?.huf?.status == 'KYC_COMPLETE' ? 'warning' : ''}
                                        >
                                            {HUFStatus[row?.huf?.status] || row?.huf?.status}
                                        </Label> : "-"}
                                </Box>
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    flexWrap="wrap"
                                    sx={{
                                        width: "auto",
                                        justifyContent: "flex-end",
                                        flex: "0 0 auto",
                                    }}
                                >
                                    {/* xs: icons, sm+: text buttons */}
                                    <Tooltip title="Edit" arrow>
                                        <span>
                                            <IconButton
                                                aria-label="Edit HUF"
                                                size="small"
                                                disabled={row?.huf?.status !== "REJECTED"}
                                                onClick={() => { navigate('/huf-registration', { state: { mode: "edit", hufData: { ...row }, url: url } }) }}
                                                sx={{
                                                    display: { xs: "inline-flex", sm: "none" },
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: 2,
                                                    color: "primary.main",
                                                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                                    border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
                                                    boxShadow: (theme) => `0 6px 14px ${alpha(theme.palette.primary.main, 0.10)}`,
                                                    transition: "transform 140ms ease, box-shadow 140ms ease, background-color 140ms ease",
                                                    '&:hover': {
                                                        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                                                        transform: "translateY(-1px)",
                                                        boxShadow: (theme) => `0 10px 22px ${alpha(theme.palette.primary.main, 0.14)}`,
                                                    },
                                                    '&:active': {
                                                        transform: "translateY(0px)",
                                                        boxShadow: (theme) => `0 6px 14px ${alpha(theme.palette.primary.main, 0.10)}`,
                                                    },
                                                    '&.Mui-disabled': {
                                                        color: (theme) => alpha(theme.palette.text.primary, 0.35),
                                                        bgcolor: (theme) => alpha(theme.palette.text.primary, 0.06),
                                                        borderColor: (theme) => alpha(theme.palette.text.primary, 0.10),
                                                        boxShadow: "none",
                                                    },
                                                }}
                                            >
                                                <EditOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Delete" arrow>
                                        <span>
                                            <IconButton
                                                aria-label="Delete HUF"
                                                size="small"
                                                disabled={row?.huf?.status !== "REJECTED"}
                                                onClick={() => { setActionModal(true) }}
                                                sx={{
                                                    display: { xs: "inline-flex", sm: "none" },
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: 2,
                                                    color: "primary.main",
                                                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                                    border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
                                                    boxShadow: (theme) => `0 6px 14px ${alpha(theme.palette.primary.main, 0.10)}`,
                                                    transition: "transform 140ms ease, box-shadow 140ms ease, background-color 140ms ease",
                                                    '&:hover': {
                                                        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
                                                        transform: "translateY(-1px)",
                                                        boxShadow: (theme) => `0 10px 22px ${alpha(theme.palette.primary.main, 0.14)}`,
                                                    },
                                                    '&:active': {
                                                        transform: "translateY(0px)",
                                                        boxShadow: (theme) => `0 6px 14px ${alpha(theme.palette.primary.main, 0.10)}`,
                                                    },
                                                    '&.Mui-disabled': {
                                                        color: (theme) => alpha(theme.palette.text.primary, 0.35),
                                                        bgcolor: (theme) => alpha(theme.palette.text.primary, 0.06),
                                                        borderColor: (theme) => alpha(theme.palette.text.primary, 0.10),
                                                        boxShadow: "none",
                                                    },
                                                }}
                                            >
                                                <DeleteOutlineOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>

                                    <Button
                                        disabled={row?.huf?.status !== "REJECTED"}
                                        variant="body2"
                                        size="small"
                                        sx={{
                                            display: { xs: "none", sm: "inline-flex" },
                                            py: '8px !important',
                                            px: '5px !important',
                                            bgcolor: '#ff79711c',
                                            fontSize: { sm: 12 }
                                        }}
                                        onClick={() => { navigate('/huf-registration', { state: { mode: "edit", hufData: { ...row }, url: url } }) }}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        disabled={row?.huf?.status !== "REJECTED"}
                                        variant="body2"
                                        size="small"
                                        sx={{
                                            display: { xs: "none", sm: "inline-flex" },
                                            py: '8px !important',
                                            px: '5px !important',
                                            bgcolor: '#ff79711c',
                                            '&:hover': { cursor: 'pointer' },
                                            color: '#FF382D',
                                            fontSize: { sm: 12 }
                                        }}
                                        onClick={() => { setActionModal(true) }}
                                    >
                                        Delete
                                    </Button>
                                </Stack>
                            </Stack>
                            <Divider></Divider>
                            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                                <Typography variant="label">HUF Name</Typography>
                                <Typography variant="body2" sx={{ wordBreak: "break-word", textAlign: { xs: "left", sm: "right" } }}>
                                    {row?.huf?.legalName}
                                </Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                                <Typography variant="label">PAN Number</Typography>
                                <Typography variant="body2" sx={{ wordBreak: "break-word", textAlign: { xs: "left", sm: "right" } }}>
                                    {row?.huf?.panCardNumber}
                                </Typography>
                            </Stack>
                            {/* <Stack direction={'row'} alignItems={'center'} spacing={2} justifyContent={"space-between"}>
                                <Typography variant="label">Account Number</Typography>
                                <Typography variant="body2">{row?.huf?.bankInformation?.accNumber}</Typography>
                            </Stack>
                            <Stack direction={'row'} alignItems={'center'} spacing={2} justifyContent={"space-between"}>
                                <Typography variant="label">IFSC Code</Typography>
                                <Typography variant="body2">{row?.huf?.bankInformation?.ifsc}</Typography>
                            </Stack> */}
                            {/* <Stack direction={'row'} alignItems={'center'} spacing={2} justifyContent={"space-between"}>
                                <Typography variant="label">Account Type</Typography>
                                <Typography variant="body2">{row?.huf?.bankInformation?.accType}</Typography>
                            </Stack> */}
                            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                                <Typography variant="label">Cancel Check Image </Typography>
                                <Typography variant="body2" component="a"
                                    href={`https://d2wn9fkjg79rzz.cloudfront.net/${row?.huf?.documents[1]?.docUrl}`}
                                    download={row?.huf?.documents[1]?.docName}
                                    sx={{
                                        color: 'blue',
                                        textDecoration: 'none',
                                        wordBreak: "break-word",
                                        '&:hover': { textDecoration: 'underline' }
                                    }}
                                >
                                    Download
                                </Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                                <Typography variant="label">Huf Deed</Typography>
                                <Typography variant="body2" component="a"
                                    href={`https://d2wn9fkjg79rzz.cloudfront.net/${row.huf.documents[2]?.docUrl}`}
                                    download={row?.huf?.documents[2]?.docName}
                                    sx={{
                                        color: 'blue',
                                        textDecoration: 'none',
                                        wordBreak: "break-word",
                                        '&:hover': { textDecoration: 'underline' }
                                    }}
                                >
                                    Download
                                </Typography>
                            </Stack>
                                 <BankAccount entityId={row.huf?._id} panCardNumber={row?.huf?.panCardNumber} entityType={"HUF"} status={row?.huf?.status}/>
                            {/* blockchain acc */}
                        </Stack>

                    </CardContent>
                    {isKycApprovedOrApproved &&
                        <>
                            <Divider
                                flexItem
                                orientation={{ xs: "horizontal", md: "vertical" }}
                                sx={{ borderColor: "#00000017", borderWidth: "1px" }}
                            ></Divider>
                            {
                                row.status !== "APPROVED" || row.status !== "KYC_APPROVED" ?
                                    <HufDltWallet entityId={row?.entityId} getHufDetails={()=>getHufDetails()} /> : (
                                        <Alert severity="error" variant="outlined" sx={{ width: { xs: "100%", md: "80%" }, ml: { xs: 0, md: "10px" } }}>
                                            <Typography variant="body1" fontSize={14}>
                                                Once your KYC is approved, you can create a DLT account.
                                            </Typography>
                                        </Alert>
                                    )
                            }
                        </>
                    }
                </Card>
            )

        })

    )
}


export default HufProfile
